var _mask, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 54,
    viewBox: "0 0 46 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_19455_13701",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46 27C46 12.0883 33.9117 0 19 0H0V54H19C33.9117 54 46 41.9117 46 27Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 27C46 12.0883 33.9117 0 19 0H0V54H19C33.9117 54 46 41.9117 46 27Z",
    fill: "#A9CF3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 0H0H46ZM0 54H46H0ZM46 54V0V54ZM-1 0V54H1V0H-1Z",
    fill: "#8CAE2B",
    mask: "url(#path-1-inside-1_19455_13701)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2197 32.2803C20.4859 32.5466 20.9026 32.5708 21.1962 32.3529L21.2803 32.2803L26.2803 27.2803C26.5466 27.0141 26.5708 26.5974 26.3529 26.3038L26.2803 26.2197L21.2803 21.2197C20.9874 20.9268 20.5126 20.9268 20.2197 21.2197C19.9534 21.4859 19.9292 21.9026 20.1471 22.1962L20.2197 22.2803L24.689 26.75L20.2197 31.2197C19.9534 31.4859 19.9292 31.9026 20.1471 32.1962L20.2197 32.2803Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/RightArrow.5d82757e22dc778a4873da6fc28e9533.svg";
export { ForwardRef as ReactComponent };